// removed by extract-text-webpack-plugin
module.exports = {"App":"src-App-index__App--2a73B","App-logo":"src-App-index__App-logo--1Jdf9","App-logo-spin":"src-App-index__App-logo-spin--2MSky","App-header":"src-App-index__App-header--3RUwm","App-title":"src-App-index__App-title--YXh6I","App-intro":"src-App-index__App-intro--3AOWm"};


//////////////////
// WEBPACK FOOTER
// ./src/App/index.scss
// module id = 447
// module chunks = 0